import { Box, Flex, Grid, Text, VStack, useColorModeValue, useDisclosure } from '@chakra-ui/react'
import { PlusCircle } from '@phosphor-icons/react'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'

import Layout from 'components/ManagerLayout'
import { useSelector } from 'react-redux'
import { State } from 'state/reducers'
import ShortcutCard from 'views/Home/ShortcutCard'
import ShortcutModal from 'views/Home/ShortcutModal'

import background from 'assets/images/background.png'

const Home = () => {
    const shortcuts = useSelector(({ shortcuts }: State) => shortcuts)

    const { isOpen, onOpen, onClose } = useDisclosure()
    const borderColor = useColorModeValue('black', 'white')

    return (
        <Layout withBackground={true}>
            <Grid
                templateColumns="repeat(4, 1fr)"
                templateRows="repeat(1, 1fr)"
                gap="24px"
                w="full"
            >
                {
                    // shortcuts.map(stc => <ShortcutCard shortcutId={stc} />)
                }
                <Card>
                    <CardBody w="full" h="full">
                        <Text fontSize="lg" fontWeight="bold">Bem-vindo ao Monitoramento de Gestantes</Text>
                    </CardBody>
                </Card>
                {/* <Card h="180px" cursor="pointer" _hover={{ border: `1px solid ${borderColor}` }} transition="all ease 0.1s" onClick={onOpen}>
                    <CardBody w="full" h="full">
                        <Text>Bem-vindo ao Monitoramento de Gestantes</Text>
                        <Flex id="aa" w="full" h="full" justifyContent="center" alignItems="center">
                            <VStack>
                                <Text fontSize="md" fontWeight="bold">Adicionar atalho</Text>
                                <Box>
                                    <PlusCircle size="38" weight="duotone" />
                                </Box>
                            </VStack>
                        </Flex>
                    </CardBody>
                </Card> */}
            </Grid>
            <ShortcutModal isOpen={isOpen} onClose={onClose} />
        </Layout>
    )
}

export default Home